// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // base_url: 'https://680285ea-3cd1-4bf8-bc7d-25097fc19112.mock.pstmn.io/api/v1',
  client_id: 'fdb06246-8a6a-4ec1-a374-7975dd056323',
  base_url: 'https://euro-euron-service.duka.dev/api/v1',
  // base_url: 'http://localhost:13172/api/v1',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
